import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableAkitaProdMode, persistState } from '@datorama/akita';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import './array.extensions';

if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();

  console.error = () => {};
  console.log = () => {};
}
persistState();
const bootstrap = () =>
  platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] });
bootstrap().catch(err => console.log(err));
